import React from 'react';

export const LazyDashboardChart = React.lazy(() => import('./DashboardChartPage'));
export const LazyMapDashboard = React.lazy(() => import('./MapDashboardPage'));
